export const FULL_BUSINESS_HOURS = {
    daysOfWeek: [1, 2, 3, 4, 5, 6, 7],
    startTime: '08:00',
    endTime: '18:00',
};
export function formatTimeslotToCalendarEvent(timeslot, date // guaranteed YYYY-MM-DD
) {
    if (!timeslot)
        return {};
    const subject_count = (timeslot.subjects || []).length;
    // Normalize to HH:MM (drop seconds)
    const toTime = (t) => t.slice(0, 5); // HH:MM
    const start = `${date}T${toTime(timeslot.starts_at)}`;
    const end = `${date}T${toTime(timeslot.ends_at)}`;
    return {
        id: timeslot.id,
        title: timeslot.title,
        start,
        end,
        subject_count,
        customColor: timeslot.color,
    };
}
